import React from "react";
import { useHistory } from "react-router";
import { KButton, KIcon, KTable } from "@kyburz/kdesign-system";
import BaseLayout from "../../components/layouts/BaseLayout";
import { useStyles } from "./styles";
import useSetState from "../../hooks/useSetState";
import { iotKeyColumns } from "./iotKeyTableColumns";
import { useGetIoTKeyCommands } from "../../apiCalls/config/iotKeyCommands";
import DeleteIoTKeyCommandDialog from "./DeleteDialog/DeleteIoTKeyCommandDialog";

const IoTKeyCommands = () => {
  const classes = useStyles();
  const history = useHistory();

  const { data: iotKeysCommandsData = [], request: getIoTKeyCommands } =
    useGetIoTKeyCommands();

  const [{ showDeleteDialog, iotKeyCommandToDelete }, setState] = useSetState({
    showDeleteDialog: false,
    iotKeyCommandToDelete: undefined as {id: string, name: string} | undefined,
  });

  const columns = iotKeyColumns(history, setState);

  const onClose = () => {
    setState({ showDeleteDialog: false })
    getIoTKeyCommands();
  }

  return (
    <BaseLayout title="IoT Key Commands">
      <div className={classes.ctaContainer}>
        <KButton
          icon={<KIcon icon="plus" />}
          onClick={() => history.push("/config/iot_commands/create")}
        >
          New IoT Key Command
        </KButton>
      </div>
      <KTable data={iotKeysCommandsData} columns={columns} hasFilter />
      <DeleteIoTKeyCommandDialog
        showDeleteDialog={showDeleteDialog}
        iotKeyCommand={iotKeyCommandToDelete}
        onCloseDialog={onClose}
      />
    </BaseLayout>
  );
};

export default IoTKeyCommands;
